export const fetchJobs = async (filters) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/user/website/job/fetch`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Ensure headers are set correctly
        },
        body: JSON.stringify({ filters }), // Wrap filters in an object as the backend expects
      }
    );

    const result = await res.json();

    if (result.error) {
      console.error(result.error);
      throw new Error("Failed to fetch jobs");
    }

    return result;
  } catch (error) {
    console.error("Error fetching jobs:", error);
  }
};

export const fetchCompany = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/user/website/job/company/fetch`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const result = await res.json();

    if (result.error) {
      console.error(result.error);
      throw new Error("Failed to fetch jobs");
    }

    return result;
  } catch (error) {
    console.error("Error fetching company:", error);
  }
};

export const fetchJobDetails = async (job_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/user/website/job/fetch/${job_id}`,
      {
        method: "GET",
      }
    );
    const result = await response.json();

    return result;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPreview = async (preview_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/user/website/job/preview/${preview_id}`,
      {
        method: "GET",
      }
    );
    const result = await response.json();
    console.log("result", result);
    return result;
  } catch (e) {
    console.log(e);
  }
};

export const applyJob = async (data, platform = null) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/user/website/job/apply${
        platform ? "?platform=" + platform : ""
      }`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
  }
};

export const trackTotalVisits = async (job_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/user/website/job/track/visits?job_id=${job_id}`,
      {
        method: "GET",
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
  }
};

export const fetchCandidateAccountDetails = async (email) => {
  try {
    const response = await fetch(
      `${process.env.SERVER_URL}/user/website/job/applicant/account/details?email=${email}`,
      {
        method: "GET",
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
  }
};
